/**
 * Usernames can only have:
 * - Letters (a-z, A-Z)
 * - Numbers (0-9)
 * - Dots (.)
 * - Underscores (_)
 */
export const usernameRegex = /^[a-zA-Z0-9_.]+$/;
